import React from 'react';
import HeatmapSettingsButton from '@Containers/ResultToolbar/HeatmapSettingsButton';
import HeatmapNavigatorButton from '@Containers/ResultToolbar/HeatmapNavigatorButton';
import HeatmapLegendButton from '@Containers/ResultToolbar/HeatmapLegendButton';
import HeatmapBackToResultsButton from '@Containers/ResultToolbar/HeatmapBackToResultsButton';
import HeatmapFullScreenButton from '@Containers/ResultToolbar/HeatmapFullScreenButton';
import ExportButton from '../ExportButton';
import LimitToButton from '../LimitToButton';
import ExcludeButton from '../ExcludeButton';

import './ResultToolbarHeatmapView.scss';

export default function ResultToolbarHeatmapView(props) {
  return (
    <header className="result-toolbar result-toolbar-heatmap rx-right-gutter rx-left-gutter">
      <section className="result-toolbar-heatmap__bottom-section u-els-padding-top-1o2 u-els-padding-bottom-1o4">
        <section className="result-toolbar-heatmap__controls-left">
          <LimitToButton {...props} />
          <ExcludeButton {...props} />
          <ExportButton {...props} />
          <HeatmapSettingsButton {...props} />
          <HeatmapNavigatorButton {...props} />
          <HeatmapLegendButton {...props} />
        </section>
        <section className="result-toolbar-heatmap__controls-right">
          <HeatmapBackToResultsButton {...props} />
          <HeatmapFullScreenButton {...props} />
        </section>
      </section>
    </header>
  );
}
